/**
 * String utility functions
 */

/**
 * Convert string to URL-friendly slug (ascii lowercase only, no TR chars).
 */
export const slugify = (str) => {
  if (!str) return '';
  return String(str)
    .replace(/İ/g, 'i')
    .replace(/I/g, 'i')
    .toLocaleLowerCase('tr-TR')
    .trim()
    .replace(/ı/g, 'i')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();
};

/** Slug sadece a-z, 0-9 ve tire olabilir. */
export const isValidEventSlug = (slug) =>
  typeof slug === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug);

/**
 * Truncate string to specified length
 */
export const truncateString = (str, num) => {
  if (!str) return '';
  if (str.length > num) {
    return str.slice(0, num) + '...';
  } else {
    return str;
  }
};

export default {
  slugify,
  isValidEventSlug,
  truncateString,
};
